<script type="text/jsx">
export default {
    model: {
        prop: 'state',
    },
    props: {
        id: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        state: {
            type: null,
            default: null,
        },
        value: {
            type: null,
            default: null,
        },
        unstyled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        checked() {
            return this.state === this.value;
        },
    },
    methods: {
        markChecked() {
            if (this.state === this.value) {
                return;
            }
            this.$emit('input', this.value);
            const ripple = this.$el.querySelector('.ripple');
            ripple.classList.add('animate');
            ripple.replaceWith(ripple.cloneNode());
        },
    },
    render() {
        const bindings = {
            class: (!this.readOnly) ? { checked: this.checked } : { 'read-only': true, 'checked': this.value },
            on: { click: this.markChecked },
        };

        return <div {...bindings } class={this.unstyled ? 'ui-radio-button unstyled' : 'ui-radio-button relative flex items-center py-xxxs px-none'}>
            <div class="ripple" />
            <input type="radio" disabled={this.readOnly} checked={this.checked} name={ this.name } id={ `${this.name}${this.id}` } value={this.value} />
            <label for={ `${this.name}${this.id}` } class="pl-xxxs cursor-pointer" tabIndex="-1">{ this.$slots.default }</label>
        </div>;
    },
};
</script>
<style lang="scss" scoped>
    $check-size: 10px;

    .ui-radio-button:not(.unstyled) {
        label:focus, input:focus {
            outline: none;
        }
        input[type="radio"] {
            @apply relative w-4 h-4 border-none m-none p-none cursor-pointer;
            appearance: none;
            padding: 0 !important;
            flex-shrink: 0;
        }
        input[type="radio"]:checked:after {
            content: '';
            @apply bg-purple absolute rounded-full opacity-100;
            width: $check-size;
            height: $check-size;
            left: 3px;
            top: 3px;
        }

        input[type="radio"]:before {
            content: '';
            @apply absolute bg-white text-elephant border border-solid border-elephant w-4 h-4 rounded-full;
        }

        &.checked input[type="radio"]:disabled:after {
            content: '';
            @apply bg-charcoal absolute rounded-full opacity-100;
            width: $check-size;
            height: $check-size;
            left: 3px;
            top: 3px;
        }

        input[type="radio"]:disabled:before {
            content: '';
            @apply absolute bg-white text-elephant border border-solid border-charcoal w-4 h-4 rounded-full;
        }

        input[type="radio"]:focus:before {
            content: '';
            box-shadow: 0 0 0 2px theme('colors.azure');
        }

        &.radio-option {
            @apply items-start;

            label {
                @apply w-full;
            }

            input[type="radio"] {
                @apply mt-xxxxs;
            }
        }

        .radio {
            @apply bg-white text-elephant border border-solid border-elephant w-4 h-4 cursor-pointer;
            @apply flex items-center justify-center relative m-none p-none rounded-full;

            &.read-only {
                @apply pointer-events-none;
                &.checked {
                    .check .inner {
                        @apply bg-elephant pointer-events-none;
                    }
                }
            }
        }

        .ripple {
            @apply absolute h-4 w-4 bg-leaf rounded-full pointer-events-none opacity-0 ;
            transform: inherit;

            &.animate {
                animation: scale-circle 0.6s;
            }
        }

        @keyframes scale-circle {
            0% {
                transform: scale(1);
                opacity: 0.2;
            }
            30% {
                transform: scale(2);
                opacity: 0.3;
            }
            100% {
                transform: scale(.2);
                opacity: 0;
            }
        }
    }
</style>
